export default __webpack_public_path__ + "static/media/clock_icon.47d43ea9.png";